export const noEmailHostPlaceHolder = "noemail.com";
